// @flow

import { useCallback } from 'react';

import { type UserInputName } from '../user-input';

import {
  useUserInputValueWithFormatting,
  type FormatRaw,
  type ParseFormatted,
} from './use-user-input-value-with-formatting';

type Value = any;
type TextFieldEvent = SyntheticInputEvent<HTMLInputElement | HTMLTextAreaElement>;
type HandleChange = (event: TextFieldEvent) => void;

export function useUserInputAsTextFieldWithFormatting(
  name: UserInputName,
  formatRaw: FormatRaw,
  parseFormatted: ParseFormatted,
): [Value, HandleChange] {
  const [value, setValue] = useUserInputValueWithFormatting(name, formatRaw, parseFormatted);

  const handleChange = useCallback(
    (event: TextFieldEvent) => setValue(event.target.value),
    [setValue],
  );

  return [value, handleChange];
}
